var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcInbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 9.75C5.58579 9.75 5.25 10.0858 5.25 10.5C5.25 10.9142 5.58579 11.25 6 11.25H7.64296L9.11771 13.0656C9.45001 13.4747 9.949 13.7122 10.4761 13.7122H13.5239C14.051 13.7122 14.55 13.4747 14.8823 13.0656L16.357 11.25H18C18.4142 11.25 18.75 10.9142 18.75 10.5C18.75 10.0858 18.4142 9.75 18 9.75H16C15.7741 9.75 15.5603 9.8518 15.4179 10.0271L13.718 12.1198C13.6705 12.1783 13.5992 12.2122 13.5239 12.2122H10.4761C10.4008 12.2122 10.3295 12.1783 10.282 12.1198L8.58215 10.0271C8.43973 9.8518 8.22588 9.75 8 9.75H6Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.34464 3.25C6.72054 3.25 6.14368 3.58236 5.83066 4.12228L2.3513 10.1238C2.28504 10.2381 2.25015 10.3679 2.25014 10.5L2.25 16.729C2.24998 17.6955 3.03349 18.479 4 18.479H20C20.9665 18.479 21.75 17.6955 21.75 16.729L21.7501 10.5C21.7501 10.3679 21.7153 10.2381 21.649 10.1238L18.1696 4.12228C17.8566 3.58236 17.2797 3.25 16.6556 3.25H7.34464ZM7.12836 4.87461C7.17307 4.79748 7.25548 4.75 7.34464 4.75H16.6556C16.7448 4.75 16.8272 4.79748 16.8719 4.87461L20.2501 10.7017L20.25 16.729C20.25 16.8671 20.1381 16.979 20 16.979H4C3.86193 16.979 3.75 16.8671 3.75 16.729L3.75014 10.7017L7.12836 4.87461Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcInbox);
export default __webpack_public_path__ + "static/media/ic_inbox.204f36b467ef9d2fee6738a5c247c81c.svg";
export { ForwardRef as ReactComponent };